module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/dj-and-lighting-gear-b005089c7786d5b8fc7b3f267646f295.png";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/dj-and-lighting-gear.png
// module id = Fs0h
// module chunks = 9 12